<template>
  <div class="flex flex-wrap">
    <div class="w-full lg:w-8/12 px-4">
      <card-record title="Mi perfil" resource="" primaryKey="token" :record="userInfo" :columns="columns"
        @saveChanges="handleSave" readonly="true">
        <template v-slot:afterColumns>
          <div class="w-full lg:w-6/12 px-4">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              {{ $t('settings.language') }}
            </label>
            <LanguageSelector></LanguageSelector>
          </div>
        </template>
      </card-record>
      <CardPasswordChange />
    </div>
    <div class="w-full lg:w-4/12 px-4">
      <CardProfile :record="userInfo" />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import CardRecord from "@/components/Cards/CardRecord.vue";
import CardProfile from "@/components/Cards/CardProfile.vue";
import CardPasswordChange from "@/components/Cards/CardPasswordChange.vue";
import LanguageSelector from '../../components/Dropdowns/LanguageSelector.vue';

export default {
  components: {
    CardRecord,
    CardProfile,
    CardPasswordChange,
    LanguageSelector
  },

  data() {
    return {
      record: {},
      columns: [
        {
          name: "nombre",
          label: 'Nombre',
          type: "STRING"
        },
        {
          name: "mail",
          label: 'Email',
          type: "STRING"
        },
      ]
    }
  },

  computed: {
    ...mapState({
      isLoggedIn: state => state.auth.status.loggedIn,
      userInfo: state => state.auth.user
    })
  },

  methods: {
    handleSave(record) {
      this.record = record;
    }
  }
};
</script>
